import { makeStyles, lighten, darken } from "@material-ui/core";
import GutterOnlySprite from "Custom/Content/ProductSelector/gutter_only_sprite.png";
import RoofOnlySprite from "Custom/Content/ProductSelector/roof_only_sprite.png";
import RoofGutterSprite from "Custom/Content/ProductSelector/roof_gutter_sprite.png";

const gutterOnlySpriteUrl = `url(${GutterOnlySprite})`;
const roofOnlySpriteUrl = `url(${RoofOnlySprite})`;
const roofGutterSpriteUrl = `url(${RoofGutterSprite})`;

export const ProductsStyle = makeStyles((theme) => ({
    root: {
        marginBottom: "0",
        [theme.breakpoints.up("md")]: {
            marginBottom: "2.5rem",
        },
    },
    radioButtons: {
        display: "flex",
        "& > div": {
            flex: "1",
            flexDirection: "column",
        },
        [theme.breakpoints.up("md")]: {
            "& > div": {
                flexDirection: "row",
            },
        },
    },
    radioButton: {
        flex: "1",
        margin: "0 0.75rem 10px 0.75rem",
        maxWidth: "350px",
        "& > span.MuiButtonBase-root": {
            backgroundRepeat: "no-repeat",
            backgroundSize: "300%",
            borderRadius: "0",
            height: "197px",
            width: "100%",
            "& > span.MuiIconButton-label": {
                display: "none",
            },
        },
        "& > span.MuiFormControlLabel-label": {
            fontFamily: "Nexa Bold",
            fontSize: "18.75px",
            marginBottom: "7.5px",
            marginRight: "auto",
        },
        [theme.breakpoints.up("md")]: {
            margin: "0 0.75rem",
            maxWidth: "312px",
            "& > span.MuiButtonBase-root": {
                height: "176px",
            },
        },
        [theme.breakpoints.up("lg")]: {
            maxWidth: "350px",
            "& > div": {
                flexDirection: "row",
            },
            "& > span.MuiButtonBase-root": {
                height: "197px",
            },
        },
    },
    radioButtonRoofOnly: {
        "& > span.MuiButtonBase-root": {
            backgroundImage: roofOnlySpriteUrl,
        },
        "& > span.MuiButtonBase-root:not(.Mui-checked)": {
            backgroundPosition: "0 0",
            "&:hover": {
                backgroundPosition: "50% 0",
            },
        },
        "& > span.MuiButtonBase-root.Mui-checked": {
            backgroundPosition: "100% 0",
        },
    },
    radioButtonGutterOnly: {
        "& > span.MuiButtonBase-root": {
            backgroundImage: gutterOnlySpriteUrl,
        },
        "& > span.MuiButtonBase-root:not(.Mui-checked)": {
            backgroundPosition: "0 0",
            "&:hover": {
                backgroundPosition: "50% 0",
            },
        },
        "& > span.MuiButtonBase-root.Mui-checked": {
            backgroundPosition: "100% 0",
        },
    },
    radioButtonRoofGutter: {
        "& > span.MuiButtonBase-root": {
            backgroundImage: roofGutterSpriteUrl,
        },
        "& > span.MuiButtonBase-root:not(.Mui-checked)": {
            backgroundPosition: "0 0",
            "&:hover": {
                backgroundPosition: "50% 0",
            },
        },
        "& > span.MuiButtonBase-root.Mui-checked": {
            backgroundPosition: "100% 0",
        },
    },
}));
